import { differenceInMinutes, differenceInHours } from 'date-fns';
import IndexedDB from 'Utils/indexedDB';
import { LOCAL_STORAGE_EXPIRE_MINUTE_LIMIT } from 'Store/constants';

export const loadStateFromIndexedDB = (key, callback) => {
  IndexedDB.get(key).then(
    data => {
      if (data) {
        let returningData = data;
        if (key === 'favorites') { // favoriler eventStartDate e göre temizlenmeli
          const activefavs = returningData?.favorites?.data?.reduce((acc, cur) => {
            const startTime = new Date(cur?.startTime);
            const now = new Date();
      
            if (differenceInHours(startTime, now) >= -24) { // maç başlangıç saatinden 24 saat geçmediyse.
              acc.push(cur);
            }
            return acc;
          }, []);
      
          returningData = { ...returningData, favorites: { ...returningData.favorites, data: activefavs } };
          IndexedDB.set(key, { [key]: { ...returningData.favorites, data: activefavs }, time: new Date() })
            .catch(err => {
              console.error('[IndexedDB] set failed:', err);
            });
        } else {
          const now = new Date();
          const end = data.time ? new Date(data.time) : now;
          const duration = differenceInMinutes(now, end);
          if (duration > LOCAL_STORAGE_EXPIRE_MINUTE_LIMIT) {
            IndexedDB.remove(key).catch(err => {
              console.error('[IndexedDB] remove failed:', err);
            });
            returningData = {};
          }
        }
        callback(returningData);
      } else {
        callback();
      }
    },
    error => {
      callback();
    }
  ).catch( error => {
    callback();
  });
};

export const storeDataToIndexedDB = (type, data) => {
  IndexedDB.set(type, { [type]: data, time: new Date() }).catch(err => {
    console.error('[IndexedDB] set failed:', err);
  });
};
